var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns is-multiline is-centered"},[_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"has-text-centered"},[_vm._v(" No hay información ")])])])
}]

export { render, staticRenderFns }